import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface Item {
  id: number
  title: string
}
export interface LAgent {
  id: number
  parentId: number
  code: string
  title: string
  phone: string
  email: string
  address: string
  linkWebsite: string
  type: number
  delf: number
  // status: number
  unitTitle: any
  regionTitle: any
  nationwideTitle: any
  provinceTitle: any
  view: number
}
export interface IAgent {
  id: number
  parentId: number
  code: string
  title: string
  phone: string
  email: any
  address: string
  linkWebsite: any
  type: number
  delf: number
  status: number
}
//danh sách
export const getListAgent = async (
  limit?: number, pageNumber?: number, listProvince?: number[], unitId?: number, listType?: number[], search?: string) => {
  const path = "agent/listAgent"
  const params = {
    limit, pageNumber, listProvince, unitId, listType, search
  }
  const result: ResponseSuccessTotal<LAgent[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//thông tin
export const getInforAgent = async (
  id: number) => {
  const path = "agent/infoAgent"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IAgent> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Thêm mới đại lý
export const addAgent = async (
  code: string, title: string, unitId: number, provinceId: number, type: number, phone?: string, email?: string, address?: string, linkWebsite?: string
) => {
  const url = `agent/addAgent`;
  const params = {
    code, title, phone, email, address, unitId, provinceId, linkWebsite, type
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}
//Chỉnh sửa đại lý
export const editAgent = async (
  id: number, code: string, title: string, unitId: number, provinceId: number, type: number, phone?: string, email?: string, address?: string, linkWebsite?: string
) => {
  const url = `agent/editAgent`;
  const params = {
    id, code, title, phone, email, address, unitId, provinceId, linkWebsite, type
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}
//Xóa đại lý
export const deleteAgent = async (
  id: Number
) => {
  const url = `agent/deleteAgent`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}
export const updateAgent = async (
  id: number) => {
  const path = "agent/activeAgent"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

